export default __webpack_public_path__ + "static/media/fw-madelyn-er-Yellow Gold.3cef164a.mp4";